//import defaultDataLessonTypes from "./defaultDataLessonTypes";

const SET_SELECT_CHILD = 'SET_SELECT_CHILD';
const SET_FIELD = 'SET_FIELD';
const SET_BUTTONS_GRADES_POPUP = 'SET_BUTTONS_GRADES_POPUP';
const SET_CHILD_ATTENDANCE_STATUS = 'SET_CHILD_ATTENDANCE_STATUS';
const SET_LESSON_TYPES = 'SET_LESSON_TYPES';
const SET_STATUS = 'SET_STATUS';

const initialState = {
    selectChild: null,
    currentCourseId: null,
    groupSelect: [],
    settingsForRole: null,
    filtersButtonsGradesPopupId: 'all',
    filtersLessonTypesId: 'all',
    privateFiltersIsNoAllChildren: true,
    currentGroupsSystem: {},
    /// режим выставления оценок
    autoGradesRegim: 1, // 1 - обычный с попапом, 2 - ручной ввод, 3 - массовый ввод
    paramsAutoGradesRegim: null,
    // {
    //     type,
    //     weight,
    //     comment
    // }
    selectAutoGradesRegim: [], // выделенные ячейки
    buttonsGradesPopup: [], // грузится с бэка //сервисом
    childAttendanceStatus: [], // грузится с бэка сервисом
    lessonTypes: [], // грузится с бэка сервисом
    status: 0, // 0 - empy state, 1 - loading state, 2 - state up to date
}

const journalReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_SELECT_CHILD:
            return {
                ...state,
                selectChild: action.payload
            };
        case SET_BUTTONS_GRADES_POPUP:
            return {
                ...state,
                buttonsGradesPopup: action.payload
            };
        case SET_CHILD_ATTENDANCE_STATUS:
            return {
                ...state,
                childAttendanceStatus: action.payload
            };
        case SET_LESSON_TYPES:
            return {
                ...state,
                lessonTypes: action.payload
            };
        case SET_STATUS: {
            return {
                ...state,
                status: action.status
            };
        }
        case SET_FIELD:
            return {
                ...state,
                [action.payload.name]: action.payload.value
            };
        default:
            return state;
    }
};

export default journalReducer;

export const actionSetSelectChild = (data) => {
    return {
        type: SET_SELECT_CHILD,
        payload: data
    }
};

export const actionSetButtonsGradesPopup = (data) => {
    return {
        type: SET_BUTTONS_GRADES_POPUP,
        payload: data
    }
};

export const actionSetChildAttendanceStatus = (data) => {
    return {
        type: SET_CHILD_ATTENDANCE_STATUS,
        payload: data
    }
};

export const actionSetLessonTypes = (data) => {
    return {
        type: SET_LESSON_TYPES,
        payload: data
    }
};

export const actionSetField = ({
    name,
    value
}) => {
    return {
        type: SET_FIELD,
        payload: {
            name,
            value
        }
    }
};

export const actionSetStatus = (status) => ({
    type: SET_STATUS,
    status,
});